import { render, staticRenderFns } from "./menuContratos.vue?vue&type=template&id=7855ea8d&scoped=true"
import script from "./menuContratos.vue?vue&type=script&lang=js"
export * from "./menuContratos.vue?vue&type=script&lang=js"
import style0 from "./menuContratos.vue?vue&type=style&index=0&id=7855ea8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7855ea8d",
  null
  
)

export default component.exports